import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './HowItWorksSection.module.css';

const STEPS = [
  {
    label: 'STEP 1',
    title: 'Tell us about your case',
    body: 'About five minutes. Your name, what happened, who your attorney is, and how much you need.',
  },
  {
    label: 'STEP 2',
    title: 'We confirm it with your attorney',
    body: "We contact your attorney's office directly to verify the case. You don't have to chase anyone or explain anything twice.",
  },
  {
    label: 'STEP 3',
    title: 'Offers come in. You choose.',
    body: "Every offer shows the exact dollar amount you'd repay. Sign the one you like and the funder wires the money.",
  },
];

const HowItWorksSection = () => {
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section
      id="how"
      className={shared.section}
      ref={ref}
      data-testid="how-it-works-section"
    >
      <div className={shared.wrap}>
        <div className={`${shared.secHead} ${shared.rv}`}>
          <span className={shared.eyebrow}>Three steps</span>
          <h2>Apply Today. Get offers right away.</h2>
          <p>
            No documents to hunt down, no credit check, and nobody calls your
            employer.
          </p>
        </div>

        <div className={styles.grid}>
          {STEPS.map((step) => (
            <div key={step.label} className={`${styles.step} ${shared.rv}`}>
              <span className={styles.stepNum}>{step.label}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
